document.addEventListener('DOMContentLoaded', function() {
  if (window.pkLightboxInitialized) return;
  window.pkLightboxInitialized = true;

  // Create Lightbox HTML
  const lightbox = document.createElement('div');
  lightbox.className = 'pk-lightbox';
  lightbox.innerHTML = `
    <span class="pk-lightbox-close">&times;</span>
    <img src="" alt="Expanded Image">
  `;
  document.body.appendChild(lightbox);

  const lightboxImg = lightbox.querySelector('img');
  const closeBtn = lightbox.querySelector('.pk-lightbox-close');

  // Function to open lightbox
  function openLightbox(src) {
    lightboxImg.src = src;
    lightbox.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent scrolling
  }

  // Function to close lightbox
  function closeLightbox() {
    lightbox.classList.remove('active');
    document.body.style.overflow = '';
    // Clear src after transition to avoid flicker
    setTimeout(() => { lightboxImg.src = ''; }, 300);
  }

  // Close events
  closeBtn.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) {
      closeLightbox();
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && lightbox.classList.contains('active')) {
      closeLightbox();
    }
  });

  // Attach click events to images
  const clickableImages = document.querySelectorAll('.pk-inc-img-box img, .pk-activity-polaroid img');
  clickableImages.forEach(img => {
    // Some images might be sprites with transparent pngs overlaying bg images.
    // If they have a src, we use that. If they are just css backgrounds, we might need a different approach.
    // Assuming they are standard <img> tags with src as seen in Liquid.
    img.addEventListener('click', function() {
      // Find the best quality image url if possible, otherwise use current src
      let srcToUse = this.src;
      // If it has a srcset, we could parse it, but for Shopify, usually the src is fine or we can remove the width parameter
      // Quick shopify image sizing removal (e.g. _400x.jpg -> .jpg)
      srcToUse = srcToUse.replace(/_[0-9]+x([0-9]+)?(\.[a-zA-Z]+)$/, '$2');
      openLightbox(srcToUse);
    });
  });
});
